import React from 'react';

import Logo from '../../assets/images/static/Logo.svg';

const Loader = ({ message }) => {
  if (message) {
    return (
      <div className='loader'>
        <img loading='auto' src={Logo} alt='Logo' />
        <h2>{message}</h2>
      </div>
    );
  }

  return (
    <div className='loader'>
      <img loading='auto' src={Logo} alt='Logo' />
    </div>
  );
};

export default Loader;
